module.exports = __webpack_public_path__ + "static/media/cover-image.1f181742.jpg";